import { InventoryStockAlert } from "../../services/inventory/enums/inventory-stock-alert.enum";
import { StockLayerExpirationAlert } from "../../services/inventory/stock-layer/enums/stock-layer-expiration-alert.enum";

export const STATUS_COLORS: Record<
  string,
  'green' | 'red' | 'yellow' | 'gray'
> = {
  // ✅ Success-like statuses
  active: 'green',
  approved: 'green',
  open: 'green',
  completed: 'green',
  paid: 'green',
  purchase: 'green',
  present: 'green',
  editable: 'green',
  submitted: 'green',
  registered: 'green',

  // ⚠️ Warning statuses
  parked: 'yellow',
  pending: 'yellow',
  scheduled: 'yellow',
  'in progress': 'yellow',
  cancelled: 'red',
  [InventoryStockAlert.LOW_STOCK]: 'yellow',
  [StockLayerExpirationAlert.EXPIRING_SOON]: 'yellow',

  // 🚫 Error statuses
  closed: 'red',
  fail: 'red',
  blocked: 'red',
  refunded: 'red',
  sale: 'red',
  missing: 'red',
  [InventoryStockAlert.OUT_OF_STOCK]: 'red',
  [StockLayerExpirationAlert.EXPIRED]: 'red',
  'insufficient stock': 'red',
  locked: 'red',
  cancel: 'red',

  // 🗂️ Neutral statuses
  archived: 'gray',
  void: 'gray',
  inactive: 'gray',
  [InventoryStockAlert.NONE]: 'gray',
};
